import type { DashboardComponent } from '@/types/dashboard' // We'll create this next

import UploadsChart from '@/charts/UploadsChart.vue'
import PieChart from '@/components/PieChart.vue'
import CurrentStorage from '@/charts/CurrentStorage.vue'
import DailyUploadsChart from '@/charts/DailyUploadsChart.vue'
import TrendStatCard from '@/charts/TrendStatCard.vue'
import StorageChart from '@/charts/StorageChart.vue'
import BandwidthChart from '@/charts/BandwidthChart.vue'
import RecentUploads from '@/charts/RecentUploads.vue'
import NewUsersChart from '@/charts/NewUsersChart.vue'
import NewUsersByDayChart from '@/charts/NewUsersByDayChart.vue'
import TotalTransfersChart from '@/charts/TotalTransfersChart.vue'
import TransfersByDayChart from '@/charts/TransfersByDayChart.vue'
import TransferStats from '@/charts/TransferStats.vue'
import TransferList from '@/charts/TransferList.vue'
import CircleStat from '@/charts/CircleStat.vue'
import UploadTimeChart from '@/charts/UploadTimeChart.vue'
import ConversionTimeChart from '@/charts/ConversionTimeChart.vue'

export const availableComponents: DashboardComponent[] = [
	{ id: 1, name: 'Uploads Last 14 Days', type: 'UploadsChart', width: 2, height: 2, data: { age: 14 } },
	{ id: 2, name: 'Uploads Last 30 Days', type: 'UploadsChart', width: 2, height: 2, data: { age: 30 } },
	{ id: 7, name: 'File Types', type: 'PieChart', width: 1, height: 2, data: {} },
	{ id: 3, name: 'New Users', type: 'NewUsersChart', width: 1, height: 2, data: {} },
	{ id: 4, name: 'Info Card', type: 'InfoCard', width: 1, height: 1, data: {} },
	{ id: 5, name: 'Bandwidth Graph', type: 'BandwidthChart', width: 2, height: 2, data: {} },
	{ id: 6, name: 'Recent Uploads', type: 'RecentUploads', width: 2, height: 2, data: {} },
	{ id: 8, name: 'Transfers', type: 'TransferStats', width: 2, height: 1, data: {} },
	{ id: 9, name: 'Transfer List', type: 'TransferList', width: 2, height: 1, data: { age: 30 } },
	{ id: 10, name: 'Current Storage', type: 'CurrentStorage', width: 2, height: 1, data: { age: 30 } },
	{ id: 11, name: 'Upload Time (14 Days)', type: 'UploadTimeChart', width: 2, height: 2, data: { age: 14 } },
	{ id: 12, name: 'Upload Time (30 Days)', type: 'UploadTimeChart', width: 2, height: 2, data: { age: 30 } },
	{ id: 13, name: 'Conversion Time (14 Days)', type: 'ConversionTimeChart', width: 2, height: 2, data: { age: 14 } },
	{ id: 14, name: 'Conversion Time (30 Days)', type: 'ConversionTimeChart', width: 2, height: 2, data: { age: 30 } },
	{ id: 15, name: 'Daily Uploads', type: 'DailyUploadsChart', width: 2, height: 2, data: {} },
	{ id: 16, name: 'New Users by Day', type: 'NewUsersByDayChart', width: 2, height: 2, data: {} },
	{ id: 17, name: 'Transfers by Day', type: 'TransfersByDayChart', width: 2, height: 2, data: {} },
	{ id: 18, name: 'Total Transfers', type: 'TotalTransfersChart', width: 2, height: 2, data: {} },
	{ id: 19, name: 'Storage Over Time', type: 'StorageChart', width: 2, height: 2, data: {} },
]

export const componentMap: Record<string, any> = {
	UploadsChart,
	CurrentStorage,
	CircleStat,
	PieChart,
	TrendStatCard,
	DailyUploadsChart,
	TransferStats,
	RecentUploads,
	StorageChart,
	TransferList,
	BandwidthChart,
	NewUsersChart,
	NewUsersByDayChart,
	TotalTransfersChart,
	TransfersByDayChart,
	UploadTimeChart,
	ConversionTimeChart,
}

export const componentDescriptions: Record<string, string> = {
	BarChart: 'Displays data in a customizable chart format',
	PieChart: 'Shows proportional data as pie slices',
	CurrentStorage: 'Shows storage activity',
	DailyUploadsChart: 'Tracks daily file uploads over time',
	StorageChart: 'Visualizes storage usage metrics',
	BandwidthChart: 'Displays bandwidth consumption data',
	NewUsersChart: 'Shows new user acquisition trends',
	NewUsersByDayChart: 'Daily breakdown of new user signups',
	RecentUploads: 'Compact card displaying key metrics',
	StatsGraph: 'Combined stats and graph visualization',
	TransferStats: 'Info Card on Transfers',
	UploadTimeChart: 'Shows average upload time per day',
	ConversionTimeChart: 'Shows average media conversion time per day',
	TransfersByDayChart: 'Daily breakdown of transfer activity',
	TotalTransfersChart: 'Total transfer volume over time',
}
